import React from "react";
import { ECLDateTimePicker, ECLDialogButtonBar } from "../../../index";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";
import { translate } from "../../../../utilities/Translate";

export default function TableDateRangeFilter(props) {
   const instanceId = useSelectorId();
   function getValues() {
      const min = document.querySelector(
         "#table-range-min" + instanceId,
      )?.value;
      const max = document.querySelector(
         "#table-range-max" + instanceId,
      )?.value;
      return [new Date(min), new Date(max)];
   }

   function clearValues() {
      const min = document.querySelector("#table-range-min" + instanceId);
      const max = document.querySelector("#table-range-max" + instanceId);
      if (min)
         min.value = new Date(
            new Date(props.min).getTime() -
               new Date(props.min).getTimezoneOffset() * 60000,
         )
            .toISOString()
            .slice(0, -8);
      if (max)
         max.value = new Date(
            new Date(props.max).getTime() -
               new Date(props.max).getTimezoneOffset() * 60000,
         )
            .toISOString()
            .slice(0, -8);
   }

   return (
      <div className="table-filter-container">
         <ECLDateTimePicker
            id={"table-range-min" + instanceId}
            name={"Min"}
            date={props.defaultValueMin}
            onChange={() => {
               props.setRangeFunction(getValues());
            }}
         />

         <ECLDateTimePicker
            id={"table-range-max" + instanceId}
            name={"Max"}
            date={props.defaultValueMax}
            onChange={() => {
               props.setRangeFunction(getValues());
            }}
         />
         <ECLDialogButtonBar>
            <button
               onClick={(e) => {
                  e.preventDefault();
                  props.clearRangeFunction();
                  clearValues();
               }}
            >
               {translate("Clear")}
            </button>
         </ECLDialogButtonBar>
      </div>
   );
}
